import React from 'react';
import { useTranslation } from 'react-i18next';
import { TablePlayerList } from '../room/PlayerList';
import { getLocalPlayer, getTable } from '../room/roomSlice';
import { getGameType, getBoardType } from '../settings/settingsSlice';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { Button } from '../../components/Button';
import { LobbyChat } from './LobbyChat';

import './Lobby.css';

const TableSettings = (props) => {
  const { t } = useTranslation();
  const table = props.table;
  const gameType = useSelector(state => getGameType(state, table.gametype), shallowEqual);
  const boardType = useSelector(state => getBoardType(state, table.boardtype), shallowEqual);

  return (
    <table className="tableSettings">
      <tbody>
        <tr><td>{t('NAME')}:</td><td>{table.name}</td></tr>
        <tr><td>{t('BOARD')}:</td><td>{boardType.name}</td></tr>
        <tr><td>{t('TEMPO')}:</td><td>{gameType.name}</td></tr>
        <tr><td>{t('NUM_PLAYERS')}:</td><td>{table.players.length}/{table.numplayers}</td></tr>
        <tr><td>{t('RANKED')}:</td><td>{table.rank ? 'Yes' : 'No'}</td></tr>
      </tbody>
    </table>
  );
};

export const Lobby = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const localPlayer = useSelector(getLocalPlayer, shallowEqual);
  const table = useSelector(state => getTable(state, localPlayer.table), shallowEqual);

  if (isMobile) {
    return (
      <div className="lobby">
        <div className="box">
          <TableSettings table={table} />
        </div>
        <div className="box">
          <TablePlayerList table={table} />
        </div>
        <LobbyChat tableID={localPlayer.table}/>
        <div className="buttons">
          <Button onClick={(e) => dispatch({ type: 'action/start', payload: { id: table.id } })} disabled={table.players.length !== table.numplayers || table.hostid !== localPlayer.id}>{t('BUTTON.START')}</Button>
          <Button onClick={(e) => dispatch({ type: 'action/leave', payload: { id: table.id } })}>{t('BUTTON.LEAVE')}</Button>
        </div>
      </div>  
    );
  }

  return (
    <div className="lobby">
      <div className="column">
        <div className="box">
          <TableSettings table={table} />
        </div>
        <div className="buttons">
          <Button onClick={(e) => dispatch({ type: 'action/start', payload: { id: table.id } })} disabled={table.players.length !== table.numplayers || table.hostid !== localPlayer.id}>{t('BUTTON.START')}</Button>
          <Button onClick={(e) => dispatch({ type: 'action/leave', payload: { id: table.id } })}>{t('BUTTON.LEAVE')}</Button>
        </div>
      </div>
      <div className="column">
        <div className="box">
          <TablePlayerList table={table} />
        </div>
        <LobbyChat tableID={localPlayer.table}/>
      </div>
    </div>
  );
}
